import { isProdEnv } from './runtime-env'

const GTAG_ID = 'G-Q41X1639F3'

/**
 * A local literal. This app does not depend on `@gto/analytics`, and its constant is a
 * `gtowizard.com` host — cross-site from `rbwizard.com`, which would make the FPID cookie a
 * third-party one that Safari and Firefox block (TD-289).
 */
const GA_FIRST_PARTY_TRANSPORT_URL = 'https://xyz.rbwizard.com'
const CRISP_WEBSITE_ID = 'bb0df8af-e9f2-46b5-9eec-29d7ecb26bdd'
const CRISP_SCRIPT_URL = 'https://client.crisp.chat/l.js'

let initialized = false

export function initAnalytics() {
  if (initialized) {
    return
  }
  initialized = true

  injectCrisp()

  if (!isProdEnv()) {
    return
  }

  injectGtag()
}

function injectGtag() {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`
  document.head.appendChild(script)

  // `transport_url` MUST ride on this FIRST `config` call: gtag ignores a later one for an
  // already-configured id, so no later `config` can add it (TD-289).
  const inline = document.createElement('script')
  inline.textContent = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${GTAG_ID}', { transport_url: '${GA_FIRST_PARTY_TRANSPORT_URL}' });`
  document.head.appendChild(inline)
}

function injectCrisp() {
  const crispWindow = window as Window & {
    $crisp?: unknown[]
    CRISP_WEBSITE_ID?: string
  }
  crispWindow.$crisp = []
  crispWindow.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID

  const script = document.createElement('script')
  script.src = CRISP_SCRIPT_URL
  script.async = true
  document.head.appendChild(script)
}
